import React,{useEffect, useState} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Link,useParams,useNavigate } from "react-router-dom";
import { clearErrors, updateLogo, getSingleLogo } from "../../actions/userAction";
import { useAlert } from "react-alert";
import { Button } from "@material-ui/core";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import StorageIcon from "@material-ui/icons/Storage";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import MetaData from '../../components/MetaData';
import Loader from "../Loader";
import Sidebar from "./Sidebar";
import { LOGO_UPDATED_RESET } from "../../constants/userConstant";

const UpdateLogo = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {id} = useParams();
	const alert = useAlert();

	const { error, logo } = useSelector((state) => state.logoDetails);

	const { loading, error: updateError, isUpdated } = useSelector((state) => state.logo);

	const [name, setName] = useState("");
	const [status, setStatus] = useState("");
	const [images, setImages] = useState([]);
	const [oldImages, setOldImages] = useState([]);
	const [imagesPreview, setImagesPreview] = useState([]);

	useEffect(() => {

		if (logo && logo._id !== id) {
	      dispatch(getSingleLogo(id));
	    } else {
	      setName(logo.name);
	      setStatus(logo.status);
	      setImages(logo.images);
	    }

	    if (error) {
	      alert.error(error);
	      dispatch(clearErrors());
	    }

	    if (updateError) {
	      alert.error(updateError);
	      navigate("/admin/dashboard");
	      dispatch(clearErrors());
	    }

	    if (isUpdated) {
	      alert.success("Logo Updated Successfully");
	      navigate("/admin/logo-list");
	      dispatch({ type: LOGO_UPDATED_RESET });
	    }

	}, [dispatch, alert, error, navigate, id, isUpdated, logo, updateError]);

	const updateLogoSubmitHandler = (e) => {
	    e.preventDefault();

	    const myForm = new FormData();

	    if (images && images.length > 0) {
		    images.forEach((image) => {
		      myForm.append("images", image);
		    });
		  }

	    myForm.set("name", name);
	    myForm.set("status", status);
	    // images.forEach((image) => {
	    //   myForm.append("images", image);
	    // });
	    dispatch(updateLogo(id, myForm));

	};

	const updateLogoImagesChange = (e) => {
	    // const files = Array.from(e.target.files);

	    // setImages([]);
	    // setImagesPreview([]);
	    // setOldImages([]);

	    // files.forEach((file) => {
	    //   const reader = new FileReader();

	    //   reader.onload = () => {
	    //     if (reader.readyState === 2) {
	    //       setImagesPreview((old) => [...old, reader.result]);
	    //       setImages((old) => [...old, reader.result]);
	    //     }
	    //   };

	    //   reader.readAsDataURL(file);
	    // });
	    const filesArray = Array.from(e.target.files);
  setImages(filesArray);
	};

	return (
		<>
			{loading ? (
        <Loader />
      ) : (
      	<>

		      		<div className="dashboard-panel">
					<div className="container">
						<MetaData title={`Create Product`} />
						<div className="row">
							<Sidebar />	
							<div className="col-lg-9 col-md-8">
								<div className="dashboardContainer">
							        <h3>Update Logo</h3>
							        <div className="col-12">
		                    			<form
							            className="createProductForm"
							            encType="multipart/form-data"
							            onSubmit={updateLogoSubmitHandler}
							          >

							          	<div className="single-form">
							          	<label>Logo Name</label>
							             <input
							                type="text"
							                placeholder="Name"
							                required
							                value={name}
							                onChange={(e) => setName(e.target.value)}
							              />
							            </div>
							            
							          
							          	<div className="single-form">
							          	<label>Logo Status</label>
							          	<select value={status} onChange={(e) => setStatus(e.target.value)}>
							                <option value="">Choose Status</option>
							                <option value="show">Show</option>
							                <option value="hide">Hide</option>
							              </select>
							            </div>

							            

							            <div className="single-form" id="createCateFormFile">
							            <label>Logo Image</label>
							              <input
							                type="file"
							                accept="image/*"
							                onChange={updateLogoImagesChange}
							                multiple={true}
							              />
							            </div>

							            {/*<div id="createCateFormImage">
							              {oldImages &&
							                oldImages.map((image, index) => (
							                  <img key={index} src={image.url} alt="Old Logo Preview" />
							                ))}
							            </div>

							            <div className="single-form" id="createCateFormImage">
							              {imagesPreview.map((image, index) => (
							                <img key={index} src={image} alt="Logo Preview" />
							              ))}
							            </div>
							            */}
							            <button
							            className="mt-2 btn btn-primary btn-hover-dark paymentFormBtn"
							              id="createCateBtn"
							              type="submit"
							              disabled={loading ? true : false}
							            >
							              Create
							            </button>
							          </form>
		  						    </div>
							    </div>
							</div>
						</div>
					</div>
					</div>
</>
		)}
		      	
		</>
	)
}

export default UpdateLogo